/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/Ansi.ts
 * @create:      2025-06-29 08:08:53.028
 * @modify:      2025-07-11 21:19:12.774
 * @version:     6.0.0
 * @times:       6
 * @lines:       193
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { AnsiColors_Reset, AnsiColors_Black, AnsiColors_Red, AnsiColors_Green, AnsiColors_Yellow, AnsiColors_Blue, AnsiColors_Magenta, AnsiColors_Cyan, AnsiColors_BrightBlack, AnsiColors_BrightRed, AnsiColors_BrightGreen, AnsiColors_BrightYellow, AnsiColors_BrightBlue, AnsiColors_BrightMagenta, AnsiColors_BrightCyan, AnsiColors_Background_Black, AnsiColors_Background_Red, AnsiColors_Background_Green, AnsiColors_Background_Yellow, AnsiColors_Background_Blue, AnsiColors_Background_Magenta, AnsiColors_Background_Cyan, AnsiColors_Background_BrightBlack, AnsiColors_Background_BrightRed, AnsiColors_Background_BrightGreen, AnsiColors_Background_BrightYellow, AnsiColors_Background_BrightBlue, AnsiColors_Background_BrightMagenta, AnsiColors_Background_BrightCyan } from "./const/AnsiColors";
import { SurroundBy } from "./string/SurroundBy";

export function AnsiTextColor(text: string, ansiColor: string, resetRight = true) {
    return SurroundBy(text, ansiColor, resetRight ? AnsiColors_Reset : "");
}

export function AnsiTextBlack(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Black, resetRight);
}

export function AnsiTextRed(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Red, resetRight);
}

export function AnsiTextGreen(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Green, resetRight);
}

export function AnsiTextYellow(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Yellow, resetRight);
}

export function AnsiTextBlue(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Blue, resetRight);
}

export function AnsiTextMagenta(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Magenta, resetRight);
}

export function AnsiTextCyan(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Cyan, resetRight);
}

export function AnsiTextWhite(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Red, resetRight);
}


export function AnsiTextBrightBlack(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightBlack, resetRight);
}

export function AnsiTextBrightRed(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightRed, resetRight);
}

export function AnsiTextBrightGreen(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightGreen, resetRight);
}

export function AnsiTextBrightYellow(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightYellow, resetRight);
}

export function AnsiTextBrightBlue(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightBlue, resetRight);
}

export function AnsiTextBrightMagenta(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightMagenta, resetRight);
}

export function AnsiTextBrightCyan(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightCyan, resetRight);
}

export function AnsiTextBrightWhite(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_BrightRed, resetRight);
}


export function AnsiTextBackgroundBlack(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Black, resetRight);
}

export function AnsiTextBackgroundRed(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Red, resetRight);
}

export function AnsiTextBackgroundGreen(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Green, resetRight);
}

export function AnsiTextBackgroundYellow(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Yellow, resetRight);
}

export function AnsiTextBackgroundBlue(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Blue, resetRight);
}

export function AnsiTextBackgroundMagenta(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Magenta, resetRight);
}

export function AnsiTextBackgroundCyan(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Cyan, resetRight);
}

export function AnsiTextBackgroundWhite(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_Red, resetRight);
}


export function AnsiTextBackgroundBrightBlack(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightBlack, resetRight);
}

export function AnsiTextBackgroundBrightRed(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightRed, resetRight);
}

export function AnsiTextBackgroundBrightGreen(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightGreen, resetRight);
}

export function AnsiTextBackgroundBrightYellow(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightYellow, resetRight);
}

export function AnsiTextBackgroundBrightBlue(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightBlue, resetRight);
}

export function AnsiTextBackgroundBrightMagenta(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightMagenta, resetRight);
}

export function AnsiTextBackgroundBrightCyan(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightCyan, resetRight);
}

export function AnsiTextBackgroundBrightWhite(text: string, resetRight = true) {
    return AnsiTextColor(text, AnsiColors_Background_BrightRed, resetRight);
}

/**
 * @since 4.1.0
 * @version 2022-06-26
 * @see https://github.com/chalk/ansi-regex/blob/main/index.js
 */
export function GetAnsiRegex() {
    const pattern = [
        "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
        "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-nq-uy=><~]))",
    ].join("|");

    return new RegExp(pattern, "g");
}

/**
 * @since 4.1.0
 * @version 2022-06-26
 * @see https://github.com/chalk/strip-ansi/blob/main/index.js
 */
export function StripAnsi(text: string) {
    return text.replace(GetAnsiRegex(), "");
}
